var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading && !_vm.hasOrder)?_c('div',{staticClass:"text-center text-dark m-0 p-4 display-4 d-flex justify-content-center align-items-center"},[_c('i',{staticClass:"fad fa-spinner fa-fw fa-2x fa-spin text-danger mr-4"}),_c('strong',[_vm._v("Nahrávám zakázku ...")])]):_vm._e(),(_vm.hasOrder)?_c('RouterView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }